// extracted by mini-css-extract-plugin
export default {"link":"_ca0227e0"};